import type { Resource } from '../../';
export const product_details_artlabs_viewInAr: Resource = {"default":"View in AR"};
